import React from "react";
import { Compose24Regular } from "@fluentui/react-icons";
import { PLUS_FAB_VAR } from "../../windowManager/bottomBars";
import "./mailMobil.css";

/**
 * Runder Knopf „Neue Mail" unten rechts (Outlook iOS) — über der App-Navigation,
 * nie darauf. Solange er steht, rückt der Melde-Knopf über ihn (`--plus-fab-h`,
 * dasselbe Muster wie das Plus der Vorgangsansicht).
 */
export const NeueMailKnopf: React.FC<{ onClick: () => void; disabled?: boolean }> = ({ onClick, disabled }) => {
    React.useEffect(() => {
        const root = document.documentElement;
        root.style.setProperty(PLUS_FAB_VAR, "74px");
        return () => {
            root.style.removeProperty(PLUS_FAB_VAR);
        };
    }, []);
    return (
        <button
            type="button"
            className="mm-fab"
            aria-label="Neue Mail"
            title="Neue Mail"
            onClick={onClick}
            disabled={disabled}
        >
            <Compose24Regular />
        </button>
    );
};
